export default __webpack_public_path__ + "static/media/hero_test.86548872.jpg";